var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 11,
    fill: "#FEE685"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56623_22557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6122 17.9434C23.3516 15.8172 21.6735 14.1434 19.5467 13.8882C19.3636 13.8673 19.1794 13.8569 18.9951 13.8568C17.1155 13.8597 15.4231 14.9956 14.7083 16.734C13.9935 18.4724 14.3975 20.4703 15.7315 21.7945C16.4408 22.4738 16.8471 23.41 16.8587 24.3922V24.9286H21.1444V24.3894C21.1476 23.4258 21.5396 22.5044 22.2315 21.8338C23.2766 20.8254 23.7878 19.3851 23.6121 17.9436V17.9434H23.6122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9985 28.4999C19.4524 28.4994 19.8569 28.2134 20.0087 27.7856H17.9883C18.1401 28.2134 18.5446 28.4994 18.9985 28.4999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2148 26.7143C17.2151 26.9114 17.3748 27.0711 17.572 27.0714H20.4291C20.6263 27.0711 20.786 26.9114 20.7863 26.7143V25.6428H17.2148V26.7143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9995 11.7143C19.3939 11.7143 19.7138 11.3945 19.7138 11V9.2143C19.7138 8.8198 19.3939 8.5 18.9995 8.5C18.605 8.5 18.2852 8.8198 18.2852 9.2143V11C18.2852 11.3945 18.605 11.7143 18.9995 11.7143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9718 13.482C13.2545 13.752 13.6994 13.752 13.9821 13.482C14.1161 13.3481 14.1913 13.1664 14.1913 12.9769C14.1913 12.7875 14.1161 12.6057 13.9821 12.4718L12.7193 11.2093C12.5854 11.0753 12.4037 11 12.2143 11C12.0249 11 11.8432 11.0753 11.7093 11.2093C11.5753 11.3432 11.5 11.5248 11.5 11.7143C11.5 11.9038 11.5753 12.0854 11.7093 12.2193L12.9718 13.482Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2143 18.4999C12.2143 18.1054 11.8945 17.7856 11.5 17.7856H9.7143C9.31996 17.786 9.00039 18.1056 9 18.4999C9.00039 18.8943 9.31996 19.2138 9.7143 19.2142H11.5C11.8945 19.2142 12.2143 18.8944 12.2143 18.4999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6623 23.332C13.4154 23.266 13.1521 23.3369 12.9718 23.518L11.7093 24.7807C11.5753 24.9146 11.5 25.0963 11.5 25.2857C11.5 25.4752 11.5753 25.6568 11.7093 25.7908C11.9918 26.0607 12.4367 26.0607 12.7193 25.7908L13.982 24.5282C14.163 24.3479 14.234 24.0846 14.168 23.8377C14.102 23.5908 13.9092 23.398 13.6623 23.332Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.029 23.5179C24.8487 23.3369 24.5854 23.266 24.3385 23.332C24.0916 23.3979 23.8988 23.5908 23.8328 23.8376C23.7669 24.0845 23.8378 24.3478 24.0188 24.5281L25.2815 25.7907C25.5641 26.0606 26.009 26.0606 26.2916 25.7907C26.4256 25.6568 26.5008 25.4751 26.5008 25.2856C26.5008 25.0962 26.4256 24.9146 26.2916 24.7806L25.029 23.5179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2852 17.7856H26.4995C26.105 17.7856 25.7852 18.1054 25.7852 18.4999C25.7852 18.8944 26.105 19.2142 26.4995 19.2142H28.2852C28.6796 19.2142 28.9995 18.8944 28.9995 18.4999C28.9995 18.1054 28.6796 17.7856 28.2852 17.7856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0281 13.482L26.2907 12.2193C26.4711 12.0389 26.5416 11.7759 26.4755 11.5294C26.4095 11.2829 26.217 11.0904 25.9705 11.0244C25.724 10.9583 25.461 11.0288 25.2806 11.2092L24.0179 12.4717C23.8839 12.6057 23.8086 12.7874 23.8086 12.9769C23.8086 13.1663 23.8839 13.348 24.0179 13.482C24.3005 13.752 24.7455 13.752 25.0281 13.482Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56623_22557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyPoints);
export default __webpack_public_path__ + "static/media/key-points.ebb6d8977d545014ab0ca4766198a183.svg";
export { ForwardRef as ReactComponent };